<div class="container-fluid px-md-5 px-auto">
  <div class="mb-3">
    <xen-title-section subtitle="Real-time information" title="Status of Travelgate Services"></xen-title-section>
  </div>
  <div class="mb-3">
    <a
      class="btn btn-primary"
      href="https://discord.com/channels/1121158946074402916/1238058167385067601"
      target="_blank"
      rel="noopener noreferrer"
      >Open status channel in Discord</a
    >
  </div>
  <div id="widgetbot-container"></div>

  @if (showWidgetFallback) {
    <div class="alert alert-warning mt-3" role="alert">
      We could not load the embedded status widget in this environment. Please use the Discord link above.
    </div>
  }
</div>
